<section *ngIf="createTrackerForm" class="tracker-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>Create New Offline Tracker</h3>
            </div>
            <div class="col-12">
              <form [formGroup]="createTrackerForm">
                <div class="row">
                  <div class="sub-header">Basic Info</div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <app-category-selector
                          [module]="module"
                          (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label class="form-label">Task Name <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Task Name Select"
                        formControlName="name"
                        [ngClass]="{ 'is-invalid': f[NAME_CONTROL_NAME].errors && f[NAME_CONTROL_NAME].touched }"
                        (change)="onTaskNameSelectChange($event.target.value)">
                        <option [disabled]="true" selected value="">Select Name</option>
                        <option *ngFor="let offlineTrackerTaskType of offlineTrackerTaskTypes"
                                value="{{ offlineTrackerTaskType?.code }}">
                          {{ offlineTrackerTaskType?.label }}
                        </option>
                      </select>
                      <app-validation
                        field="name"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select Task Name'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <app-company-selector
                        (selectedValueChange)="handleCompanySelectedValue($event)"
                        [companyId]="selectedEmployeeCompanyEntityId"></app-company-selector>
                      <app-validation
                        field="companyEntityId"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <app-employee-selector
                        (onChange)="handleEmployeeValueChange($event)"
                        (selectedEmployee)="handleEmployeeSelected($event)"
                        [isMandatory]="isEmployeeCodeMandatory"></app-employee-selector>
                      <app-validation
                        *ngIf="isEmployeeCodeMandatory"
                        field="employeeCode"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select/enter Valid Employee',
                          minLength: 'Employee Id should have minimum 3 characters',
                          maxLength: 'Employee Id should have maximum 40 characters',
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="employeeStatus" class="form-label">Employee Status<sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Employee Status"
                        formControlName="employeeStatus"
                        [ngClass]="{
                          'is-invalid': f['employeeStatus'].errors && f['employeeStatus'].touched
                        }">
                        <option [disabled]="true" selected value="">Select Employee Status</option>
                        <option *ngFor="let option of employeeStatusOptionsList" value="{{ option?.key2 }}">
                          {{ option?.key1 }}
                        </option>
                      </select>
                      <app-validation
                        field="employeeStatus"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="firstName" class="form-label">First Name <sup>*</sup></label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="firstName"
                        [ngClass]="{
                          'is-invalid': f['firstName'].errors && f['firstName'].touched
                        }" />
                      <app-validation
                        field="firstName"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required',
                          minLength: 'First Name should have a minimum of 3 characters',
                          maxLength: 'First Name should not exceed 100 characters',
                          pattern: 'First Name should contain only alphabets and spaces'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="middleName" class="form-label">Middle Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="middleName"
                        [ngClass]="{
                          'is-invalid': f['middleName'].errors && f['middleName'].touched
                        }" />
                      <app-validation
                        field="middleName"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required',
                          minLength: 'Middle Name should have a minimum of 3 characters',
                          maxLength: 'Middle Name should not exceed 100 characters',
                          pattern: 'Middle Name should contain only alphabets and spaces'
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="lastName" class="form-label">Last Name <sup>*</sup></label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="lastName"
                        [ngClass]="{
                          'is-invalid': f['lastName'].errors && f['lastName'].touched
                        }" />
                      <app-validation
                        field="lastName"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required',
                          minLength: 'Last Name should have a minimum of 3 characters',
                          maxLength: 'Last Name should not exceed 100 characters',
                          pattern: 'Last Name should contain only alphabets and spaces'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="uan" class="form-label">UAN <sup>*</sup></label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Last name"
                        formControlName="uanNumber"
                        (input)="validateUAN($event)"
                        [ngClass]="{
                          'is-invalid': f['uanNumber'].errors && f['uanNumber'].touched
                        }"
                        maxlength="12" />
                      <app-validation
                        field="uanNumber"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This is a mandatory field',
                          invalid: 'Invalid UAN number',
                          pattern: 'Invalid UAN format, should contain only numbers',
                          minLength: 'UAN number should have a minimum of 12 characters',
                          maxLength: 'UAN number should not exceed 12 characters',
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="memberId" class="form-label">Unique Member ID <sup>*</sup></label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Member Id"
                        formControlName="memberId"
                        (input)="validatePFNumber($event)"
                        [ngClass]="{
                          'is-invalid': f['memberId'].errors && f['memberId'].touched
                        }"
                        maxlength="21" />
                      <app-validation
                        field="memberId"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This is a mandatory field',
                          invalid: 'Invalid Unique Member ID',
                          pattern: 'Invalid UAN format, should contain only numbers',
                          minLength: 'Unique Member ID should have a minimum of 21 characters',
                          maxLength: 'Unique Member ID should not exceed 21 characters',
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <app-multi-dropdown-add-option
                        [options]="natureOfIssueOptionsList"
                        label="Nature of Issue"
                        (optionSelected)="onMultiSelectChange($event, 'natureOfIssue')"
                        (newOptionAdded)="onNewOptionAdded($event, 'natureOfIssue')">
                      </app-multi-dropdown-add-option>
                      <app-validation
                        field="natureOfIssue"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="additionalDetails" class="form-label">Additional Details</label>
                      <textarea
                        class="form-control"
                        formControlName="additionalDetails"
                        [ngClass]="{
                          'is-invalid': f['additionalDetails'].errors && f['additionalDetails'].touched
                        }"></textarea>
                      <app-validation
                        field="additionalDetails"
                        [form]="createTrackerForm"
                        [error]="{
                          minLength: 'Additional Details should have a minimum of 3 characters',
                          maxLength: 'Additional Details should should not exceed 100 characters',
                        }"></app-validation>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <app-multi-dropdown-add-option
                        [options]="documentsReceivedOptionsList"
                        label="Documents Received"
                        (optionSelected)="onMultiSelectChange($event, 'receivedDocuments')"
                        (newOptionAdded)="onNewOptionAdded($event, 'receivedDocuments')">
                      </app-multi-dropdown-add-option>
                      <app-validation
                        field="receivedDocuments"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="mobileNumber" class="form-label">Mobile Number</label>
                      <div class="mobile-input-group">
                        <select
                          formControlName="mobileCountryCode"
                          class="form-control mobile-country-code"
                          [ngClass]="{ 'is-invalid': f?.['mobileCountryCode']?.errors && f?.['mobileCountryCode']?.touched }">
                          <option *ngFor="let countryCode of countryCodes">
                            {{ countryCode.dialCode }}
                          </option>
                        </select>

                        <input
                          type="text"
                          placeholder=""
                          value=""
                          formControlName="mobileNumber"
                          class="form-control form-control-fixed-phone mobile-number-input"
                          [ngClass]="{ 'is-invalid': f?.['mobileNumber']?.errors && (f?.['mobileNumber']?.touched) }"
                          maxlength="10" />
                      </div>
                      <app-validation
                        field="mobileNumber"
                        [form]="createTrackerForm"
                        [error]="{ pattern: 'Please enter a valid 10-digit mobile number' }">
                      </app-validation>
                      <app-validation
                        field="mobileCountryCode"
                        [form]="createTrackerForm"
                        [error]="{ pattern: 'This field is required' }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="emailId" class="form-label">Mail ID<sup *ngIf="isEmailIdMandatory">*</sup></label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="emailId"
                        [ngClass]="{
                          'is-invalid': f['emailId'].errors && f['emailId'].touched
                        }" />
                      <app-validation
                        *ngIf="isEmailIdMandatory"
                        field="emailId"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                      <app-validation
                        field="emailId"
                        [form]="createTrackerForm"
                        [error]="{
                          email: 'Enter a valid email Id',
                          minLength: 'Email Id should have a minimum of 3 characters',
                          maxLength: 'Email Id should should not exceed 70 characters',
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <app-multi-dropdown-add-option
                        [options]="receivedModeOptionsList"
                        label="Received Mode"
                        (optionSelected)="onMultiSelectChange($event, 'receivedMode')"
                        (newOptionAdded)="onNewOptionAdded($event, 'receivedMode')">
                      </app-multi-dropdown-add-option>
                      <app-validation
                        field="receivedMode"
                        [form]="createTrackerForm"
                        [error]="{
                          required: 'This field is required'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="receivedDate" class="form-label">Received Date</label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="receivedDate"
                        [ngClass]="{
                          'is-invalid': f['receivedDate'].errors && f['receivedDate'].touched
                        }" />
                      <app-validation
                        field="receivedDate"
                        [form]="createTrackerForm"
                        [error]="{
                          futureDate: 'Future date is not allowed'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="row">
                    <div class="sub-header">Status Info</div>
                    <div class="col-md-8">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label for="currentStatus" class="form-label">Current Status<sup>*</sup></label>
                            <select
                              class="form-select"
                              aria-label="Current Status"
                              formControlName="status"
                              [ngClass]="{
                                'is-invalid': f['status'].errors && f['status'].touched
                              }">
                              <option [disabled]="true" selected value="">Select Current Status</option>
                              <option *ngFor="let option of offlineTrackerTaskTypes?.[0].statusList"
                                      value="{{ option?.code }}">
                                {{ option?.label }}
                              </option>
                            </select>
                            <app-validation
                              field="status"
                              [form]="createTrackerForm"
                              [error]="{
                                required: 'This field is required'
                              }"></app-validation>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label for="acknowledgeSharedStatus" class="form-label"
                              >Acknowledge Shared Status <sup *ngIf="isAcknowledgeSharedStatusMandatory">*</sup></label
                            >
                            <select
                              class="form-select"
                              aria-label="Acknowledge Shared Status"
                              formControlName="acknowledgeSharedStatus"
                              [ngClass]="{
                                'is-invalid':
                                  f['acknowledgeSharedStatus'].errors && f['acknowledgeSharedStatus'].touched
                              }">
                              <option selected value="">Select Acknowledge Shared Status</option>
                              <option
                                *ngFor="let acknowledgeShareStatus of acknowledgeShareStatusOptionsList"
                                value="{{ acknowledgeShareStatus?.key2 }}">
                                {{ acknowledgeShareStatus?.key1 }}
                              </option>
                            </select>
                            <app-validation
                              field="acknowledgeSharedStatus"
                              [form]="createTrackerForm"
                              [error]="{
                                required: 'This field is required'
                              }"></app-validation>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label for="statusDate" class="form-label">Status Date</label>
                            <input
                              type="date"
                              class="form-control"
                              formControlName="statusDate"
                              [ngClass]="{
                                'is-invalid': f['statusDate'].errors && f['statusDate'].touched
                              }" />
                            <app-validation
                              field="statusDate"
                              [form]="createTrackerForm"
                              [error]="{
                                futureDate: 'Future date is not allowed'
                              }"></app-validation>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="mb-3">
                            <label for="requestCompletionStatus" class="form-label"
                              >Request Completion Status<sup>*</sup></label
                            >
                            <select
                              class="form-select"
                              aria-label="Request Completion Status"
                              formControlName="requestCompletionStatus"
                              [ngClass]="{
                                'is-invalid':
                                  f['requestCompletionStatus'].errors && f['requestCompletionStatus'].touched
                              }">
                              <option [disabled]="true" selected value="">Select Request Completion Status</option>
                              <option
                                *ngFor="let requestCompletionStatus of requestCompletionStatusOptionsList"
                                value="{{ requestCompletionStatus?.key2 }}">
                                {{ requestCompletionStatus?.key1 }}
                              </option>
                            </select>
                            <app-validation
                              field="requestCompletionStatus"
                              [form]="createTrackerForm"
                              [error]="{
                                required: 'This field is required'
                              }"></app-validation>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="remarks" class="form-label">Remarks</label>
                        <textarea
                          class="form-control"
                          formControlName="remarks"
                          style="height: 124px"
                          [ngClass]="{
                            'is-invalid': f['remarks'].errors && f['remarks'].touched
                          }"></textarea>
                        <app-validation
                          field="remarks"
                          [form]="createTrackerForm"
                          [error]="{
                          minLength: 'Remarks should have a minimum of 3 characters',
                          maxLength: 'Remarks should should not exceed 300 characters',
                        }"></app-validation>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                    <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE & EXIT</button>
                    <button type="button" class="btn-discard" (click)="exit()">EXIT</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
